import React from "react";
import useFunnelNavigation from "../hooks/useFunnelNavigation";
import { getBrand } from "../utils/getBrand";

const Logo = ({ logoHasRedirect = false }) => {
  const { navigateTo } = useFunnelNavigation();
  const {brandName, brandLogo, brandLogoStyle } = getBrand();

  return (
    <div className="flex items-center gap-1">
      {logoHasRedirect ? (
        <button 
          onClick={() => navigateTo("landing", {}, {}, 6)}
          className="cursor-pointer"
        >
          <img src={brandLogo} alt={brandName} className={brandLogoStyle} />
        </button>
      ) : (
        <img src={brandLogo} alt={brandName} className={brandLogoStyle} />
      )}
    </div>
  );
};

export default Logo;
